import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import axios from "axios";
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
function Items({ currentItems ,balanceCoin,varizchange,bardashtchange,coinchange,coinbchange,listFavorite,setFavoriteCoins}) {
   

    const [TeterPriceBuy,setTeterPriceBuy] = useState()
    const [TeterPriceSell,setTeterPriceSell] = useState()
    const [coinSelected,setCoinSelected] = useState('')
    const [varizIsOpen,setVarizIsOpen] = useState(false)
    const [bardashtIsOpen,setBardashtIsOpen] = useState(false)
    const [favoritList,setFavoritList] = useState(listFavorite)
    const [coinFavorite,setCoinFavorite] = useState('')
    const [ClickOnFav,setClickOnFav] = useState(false)

    

    useEffect(()=>{








        axios.get('https://api.sinatether.com/Auth/get_favorite_list').then((res)=>{


            if(res.status == 200){


                setFavoritList(res.data['list_favorite'])
            }
             
  
  
        })
      },[])




    function handleTofavorite(event){

        let name = event.target.id

        axios.post('https://api.sinatether.com/Auth/add_to_favorite',{"coin":name}).then((res)=>{


        if (res.data['status'] == "200"){

            setFavoritList(res.data['list'])
            setFavoriteCoins(res.data['list'])
            toast.success(res.data['message'],
            {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                })
        }



        })



    }

    


    function handelvariz(event) {
        coinchange(event.target.value)
         varizchange(true)
     }

     function handelbardasht(event){
        coinbchange(event.target.value)
        bardashtchange(true)
     }



   

     



    useEffect(async()=>{
        axios.get('https://api.sinatether.com/Auth/GetTeter').then((res)=>{

            if (res.status==200){
                 setTeterPriceBuy(res.data['teterprice']['buy'])
                 setTeterPriceSell(res.data['teterprice']['sell'])

            }

       })
    },[])

    return (
        <>
    {currentItems && favoritList && currentItems.map((sym) => (

<div className="accordion-item">
<h2 className="accordion-header border-top py-1" id={`heading${sym['symbol']}`}>
    <button className="accordion-button  pl-1 pr-0 pt-0 pb-0 collapsed" type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${sym['symbol']}`}
            aria-expanded="true"
            aria-controls={`collapse${sym['symbol']}`}>
        <img className='heart-style' id={sym['symbol'].split('-')[0]} src={`https://static.sinatether.com/images/${favoritList.includes(sym['symbol'].split('-')[0]) ? 'inheart' : 'outheart'}.svg`} onClick={handleTofavorite} />

        <Link className="col-4 pointer linkStyle"
           to={`/${sym['symbol'].split('-')[0]}`}>
            <div className="text-black">
                <img className="imgcoin "
                     src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
                <span
                    className="spanHeaderAcc">  <span
                    className="ft-external-link text-large text-normal dis-grid text-dark">{sym['persionName'].length >=12 ? `${sym['persionName'].slice(0,9)}..`: sym['persionName']}
                    <span
                    className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>
                    </span>
                    
                    </span>

            </div>
        </Link>


        <div
            className="col-4 pointer text-right text-blue-primery text-large text-normal text-dark"
        >{new Intl.NumberFormat("fa",{maximumFractionDigits:sym['sell']>1 ? 3 : 13 }).format(sym['sell'])}
         
            </div>
                <div
                className="col-3 pointer text-right text-blue-primery text-large priceTt"
            >

            <span
                className={'text-normal priceTt'}>
                {sym['changeRate']>=0 ?
                    <>


                          <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                          <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                          <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" stroke-width="1.333"/>
                          <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" stroke-width="1.333"/>
                        </svg>


                <span className={'text-success pl-1'}>
                    {sym['changeRate']}%

                </span>
                          </>

                    :

                    <>






            <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
              <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" stroke-width="1.333"/>
              <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" stroke-width="1.333"/>
            </svg>



                <span className={'text-danger pl-1'}>
                    {-1 * Number(sym['changeRate'])}%

                </span>


                    </>
                }
            </span>


            </div>


    </button>
</h2>
<div id={`collapse${sym['symbol']}`}
     className="accordion-collapse collapse "
     aria-labelledby={`heading${sym['symbol']}`}
     data-bs-parent="#accordionExample">
    <div className="accordion-body ">


    <ul className={'ul-custom'}>
                            <li className={'col-6 pl-0 pr-0'}>
                                <h6 data-inline-formset={true}
                                    className={'col-12 text-success text-large text-normal  text-normal '}>
                                        <div className='text-normal phyrfjshbf'>
                                         خرید:
                                            </div> 
                                     {new Intl.NumberFormat("fa",{maximumFractionDigits:sym['BuyIrt'] > 1 ? 3 : 13}).format(sym['BuyIrt'])}
                                    <span className={' tomn242553 '}>تومان</span>
                                </h6>
                               


                            </li>

                            <li className={'col-6 pl-0 pr-0'}>
                                <h6 data-inline-formset={true} className={'col-12 text-large text-danger  text-normal content-left '}
                                >
                                    <div className='text-normal phyrfjshbf'>
                                         فروش:
                                    </div>
                                    {new Intl.NumberFormat("fa",{maximumFractionDigits:sym['sellIrt'] > 1 ? 3 : 13}).format(sym['sellIrt'])}
                                    <span className={' tomn242553'}>تومان</span>

                                </h6>
                                

                            </li>

                            

                        </ul>

                        <ul className='mb-0'>
                        <li className={'col-6 pl-0 pr-0'}>
                                <h6 data-inline-formset={true}
                                    className={'col-12 text-large text-normal  text-normal '}>
                                        
                                                                            
                                        {balanceCoin[sym['symbol'].split('-')[0]] ?
                                                                            <>

                                                                        <div className='text-normal phyrfjshbf'>
                                                                                                                موجودی:
                                                                                                                    </div> 
                                                                            <span
                                                                                className={'text-normal'}>{new Intl.NumberFormat("fa").format(balanceCoin[sym['symbol'].split('-')[0]])}</span>
                                                                            </>

                                                                            :
                                                                            <>


                                                                            <span
                                                                                className={'text-normal phyrfjshbf'}>موجودی:</span>
                                                                            <span
                                                                                className={'text-normal'}>{new Intl.NumberFormat("fa").format(0)}</span>
                                                                            </>
                                                } 
                                </h6>
                               


                            </li>
                        </ul>


        <div className="rowButton pt-3 pb-2 px-2 ">
                <div className="col-3 px-1 px---1">

                    <Link to={`/${sym['symbol'].split('-')[0]}`}>
                    <button
                        className="btn btn-success text-large w-100 py---5 buy mb-0 pointer ng-star-inserted btnsm b4boxnoen">خرید
                    </button>
                    </Link>
                </div>
                <div className="col-3 px-1 px---1">
                <Link to={`/${sym['symbol'].split('-')[0]}`}>

                    <button
                        className="btn btn-danger py---5 buy text-large w-100 mb-0 pointer ng-star-inserted btnsm b4boxnoen">فروش
                    </button>
                    </Link>
                </div>
                <div className="col-3 px-1 px---1">
                    <button
                        className="btn btn-outline-success py---5 buy text-large w-100 pointer mb-0 btnsm text-success"
                        value={sym['symbol'].split('-')[0]}
                        onClick={handelvariz}>واریز
                    </button>
                </div>
                <div className="col-3 px-1 px---1">
                    <button
                        className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm text-danger"
                        value={sym['symbol'].split('-')[0]}
                        onClick={handelbardasht}>برداشت
                    </button>
                </div>
            </div>



    </div>
</div>
</div>



            
                                      






        )

    )
}
        </>
    )}


export default function PageAcc({key, itemsPerPage ,items,balanceCoin,varizchange,bardashtchange,coinchange,coinbchange,listFavorite,setFavoriteCoins}) {
  // We start with an empty list of items.

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = event.selected * itemsPerPage % items.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <Items currentItems={currentItems} balanceCoin={balanceCoin} varizchange={varizchange} bardashtchange={bardashtchange} coinchange={coinchange} coinbchange={coinbchange} listFavorite={listFavorite} setFavoriteCoins={setFavoriteCoins}/>
      <ReactPaginate
        nextLabel=">>"
        onPageChange={handlePageClick}
        pageRangeDisplayed={0}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        previousLabel="<<"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />    </>
  );
}